import style from "./00_tcp.css"
import Header from '../components/header'
import Footer from '../components/footer'
export default function AccountTerms() {
    return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
      <Header />
        <div class="legal-document">
                <h1>Account and Data Deletion Policy</h1>
                <p><strong>Last Updated:</strong> 13th August 2026</p>

                <p>At <strong>SurSaathi</strong>, we respect your right to request the removal of your account and personal information from our Website.</p>

                <h2>1. Who Can Request Deletion?</h2>
                <p>You may request deletion if you have:</p>
                <ul>
                    <li>Created an account on our Website;</li>
                    <li>Registered as a music teacher;</li>
                    <li>Submitted a contact form;</li>
                    <li>Submitted an instrument or donation form; or</li>
                    <li>Provided personal information to us through another Website form or service.</li>
                </ul>

                <h2>2. How to Request Deletion</h2>
                <p>To request deletion, contact us at:</p>

                <p><strong>Email:</strong>sursaathi.music@gmail.com</p>

                <p>Please include:</p>
                <ul>
                    <li>Your name;</li>
                    <li>The email address or phone number associated with your information;</li>
                    <li>The type of account or information you want deleted; and</li>
                    <li>Any additional information reasonably necessary for us to identify your records.</li>
                </ul>

                <p>For security purposes, we may ask you to verify that you are the person who submitted the request.</p>

                <h2>3. Processing Time</h2>
                <p>We aim to process valid deletion requests <strong>within 7 days of receiving the request</strong>.</p>

                <p>Once processed, information associated with your account or profile that is intended to be publicly available will be removed from public display.</p>

                <p>For example, if you are a registered music teacher, your teacher profile or listing will be removed or disabled from public access.</p>

                <h2>4. What Happens to Your Information?</h2>
                <p>When a deletion request is processed, we will take reasonable steps to remove your information from active Website systems and public listings where applicable.</p>

                <p>However, <strong>deletion does not necessarily mean immediate permanent deletion of every record we hold</strong>.</p>

                <p>We may retain certain information where reasonably necessary for:</p>
                <ul>
                    <li>Legal or regulatory compliance;</li>
                    <li>Tax, accounting, or financial records;</li>
                    <li>Fraud prevention;</li>
                    <li>Security purposes;</li>
                    <li>Resolving disputes;</li>
                    <li>Establishing, exercising, or defending legal claims;</li>
                    <li>Maintaining records of transactions or communications;</li>
                    <li>Complying with our legal obligations; or</li>
                    <li>Protecting the rights and safety of our organisation, users, or others.</li>
                </ul>

                <h2>5. Retained Information Is Not Public</h2>
                <p>Information retained after an account or profile has been deleted will <strong>not be publicly displayed on the Website</strong>.</p>

                <p>We will not use retained information for ordinary public listings or normal user-to-user matching after deletion unless there is a lawful reason to do so.</p>

                <h2>6. Backups</h2>
                <p>Some information may remain temporarily in secure backups.</p>

                <p>Because backups may be maintained for security, disaster recovery, or technical reasons, information in backup systems may not be immediately removed when an account is deleted.</p>

                <p>Such information will be handled in accordance with our security and retention practices and will not ordinarily be restored to public-facing systems except where necessary for legitimate operational or legal reasons.</p>

                <h2>7. Teacher Listings</h2>
                <p>If you are a music teacher and request deletion:</p>
                <ul>
                    <li>Your public teacher listing will be removed or disabled;</li>
                    <li>Your publicly displayed profile information will no longer be available through the Website;</li>
                    <li>We will take reasonable steps to stop using your information for new student-teacher matching; and</li>
                    <li>Certain information may be retained as described in this policy and our Privacy Policy.</li>
                </ul>

                <p>Deletion of a teacher listing does not automatically cancel or terminate any independent teaching relationship you may have established with a student.</p>

                <h2>8. Student Information</h2>
                <p>If you have submitted a request to be connected with a music teacher and subsequently request deletion, we will remove your information from active Website systems where appropriate.</p>

                <p>Information that has already been shared with a teacher may not be possible for us to retrieve or delete from that teacher's own systems.</p>

                <h2>9. Instrument Information and Photographs</h2>
                <p>If you have submitted an instrument, instrument donation, or instrument photograph and request deletion, we will take reasonable steps to remove the associated information from active systems and public-facing areas where applicable.</p>

                <p>Information may still be retained where necessary for legitimate legal, accounting, security, or record-keeping purposes.</p>

                <h2>10. Contact Form Submissions</h2>
                <p>Deleting an account does not necessarily delete every previous email, message, or business record associated with your communications with us.</p>

                <p>We may retain such records where reasonably necessary for legal, administrative, security, dispute-resolution, or record-keeping purposes.</p>

                <h2>11. Verification and Fraud Prevention</h2>
                <p>We may decline or delay a deletion request where we reasonably believe the request is fraudulent, unauthorised, or intended to interfere with a legal, security, or investigative process.</p>

                <p>Where appropriate, we may request additional information to verify the identity of the person making the request.</p>

                <h2>12. No Public Access After Deletion</h2>
                <p>Once a deletion request has been processed, we will take reasonable steps to ensure that information intended to be removed is no longer publicly accessible through our Website.</p>

                <p>Search engines or third-party websites may continue to display previously indexed information for some time. We cannot guarantee immediate removal of information from third-party search results or websites outside our control.</p>

                <h2>13. Changes to This Policy</h2>
                <p>We may update this Account and Data Deletion Policy from time to time.</p>

                <p>The "Last Updated" date at the top of this document indicates when it was most recently revised.</p>

                <h2>14. Contact Us</h2>
                <p>
                    <strong>Sursaathi</strong><br />
                    Deletion/Privacy Email: sursaathi.music@gmail.com<br />
                    Website: sursaathi.in<br />
                </p>
                </div>
      <Footer />
    </div>
  );
}